import { render, staticRenderFns } from "./ElementStudioSpacingBars.vue?vue&type=template&id=a28e3dfa&"
import script from "./ElementStudioSpacingBars.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioSpacingBars.vue?vue&type=script&lang=ts&"
import style0 from "./ElementStudioSpacingBars.vue?vue&type=style&index=0&id=a28e3dfa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports